import { Box } from "@mantine/core";
import { Link } from "react-router-dom";
import TableRowLinkTableStyles from "@/components/shared/TableRowLinkTableStyles";
import type { CompanyProfileLinkState } from "@/shared/utils/companyProfileLink.util";

type CompanyProfileSurfaceLinkProps = {
  to: string;
  ariaLabel: string;
  linkState?: CompanyProfileLinkState;
};

/** Stretched in-app link for cards/sections (`position: relative` parent required). */
export default function CompanyProfileSurfaceLink({ to, ariaLabel, linkState }: CompanyProfileSurfaceLinkProps) {
  return (
    <>
      <TableRowLinkTableStyles />
      <Box
      component={Link}
      to={to}
      state={linkState}
      aria-label={ariaLabel}
      tabIndex={-1}
      className="gt-surface-link"
      style={{
        position: "absolute",
        inset: 0,
        zIndex: 1,
        display: "block",
      }}
    />
    </>
  );
}
